import React, { useEffect, useState } from 'react'
import { ValidatorForm } from 'react-form-validator-core'

import Fields from '@shared/form-fields'
import criminalOffences from '@constants/criminal-offences';

const ItemCriminalHistory = ({ record, fields, submit, closeModal, tableName }) => {
  const [criminalFields, setCriminalFields] = useState([]);
  const [totalConvictions, setTotalConvictions] = useState(0);
  const [newConviction, setNewConviction] = useState({ id: 0, date: '', court: '', conviction: '', sentence: '' });

  // Selectable Array for All available Courts
  const courts = [
    { label: 'Supreme', value: 'supreme' },
    { label: 'Magistrate', value: 'magistrate' },
    { label: 'Privy Council', value: 'privy council' },
    { label: 'Appeal', value: 'appeal' },
  ]

  // Grab Criminal History data from record data
  useEffect(() => {
    const criminal_history = record.criminal_history_list
    const profile_history = record.user.criminal_history_list
    const populateFields = criminal_history ? record.criminal_history_list?.map(x => (
      {
        id: parseInt(x.id),
        date: formatDate(x.date),
        court: x.court,
        conviction: x.conviction,
        sentence: x.sentence,
      }
    )) : profile_history?.map(x => (
      {
        id: parseInt(x.id),
        date: formatDate(x.date),
        court: x.court,
        conviction: x.conviction,
        sentence: x.sentence,
      }
    ))

    const sortedHistory = populateFields.sort((a, b) => a.date - b.date);

    setCriminalFields(sortedHistory);
  }, [fields, record])

  useEffect(() => {
    const computeTotal = arr => {
      setTotalConvictions(arr.length)
    }
  
    computeTotal(criminalFields)
  }, [criminalFields, setTotalConvictions])

  const on = {
    setInput: (val, i, key) => {
      const newHistory = [...criminalFields];
      newHistory[i][key] = val;

      setCriminalFields(newHistory);
    }
  }

  const formSubmit = async ev => {
    ev && ev.preventDefault()

    // Remove ID field from criminalFields state array
    const submitHistory = criminalFields.map(x => ({ id: x.id, date: x.date, court: x.court, conviction: x.conviction.trim(), sentence: x.sentence.trim() }));
    // console.log('CriminalFields\n', submitHistory);
    submit(submitHistory)
  }

  const formatDate = date =>
    typeof date == 'string'
      ? new Date(date.replace(/^(.{4})(.{2})(.{2})$/, '$1-$2-$3'))
      : date

  const addConvict = (ev) => {
    ev && ev.preventDefault()

    const newHistory = [...criminalFields];
    // Set id of new Conviction which is equal to key index
    const createConviction = { ...newConviction,
      'conviction': newConviction.conviction.trim(),
      'sentence': newConviction.sentence.trim(),
      'id': criminalFields.length + 1 }
    newHistory.push(createConviction)

    const sortedHistory = newHistory.sort((a, b) => a.date - b.date);

    // Add new conviction to original list of convictions
    setCriminalFields(sortedHistory);

    // Reset new Conviction form
    setNewConviction({ id: 0, date: '', court: '', conviction: '', sentence: '' });
  }

  const removeConvict = (conviction) => {
    const newHistory = criminalFields.filter(x => x.id != conviction.id);
    // Make sure the id field in the array changes to match the new number of records
    const newHistoryNewIdOrder = newHistory.map((x, i) => ({ ...x, id: i + 1 }))
    const sortedHistory = newHistoryNewIdOrder.sort((a, b) => a.date - b.date);

    // Add new conviction to original list of convictions
    setCriminalFields(sortedHistory);
  }


  const headings = (
    <thead>
      <tr>
        <th>Date</th>
        <th>Court</th>
        <th>Offence/s</th>
        <th>Sentence</th>
        <th>Action</th>
      </tr>
    </thead>
  )

  const colgroup = (
    <colgroup>
      <col span='1' width='200px'></col>
      <col span='1' width='180px'></col>
      <col span='1' width='200px'></col>
      <col span='1' width='200px'></col>
      <col span='1' width='142px'></col>
    </colgroup>
  )

  const addItemRow = (
    <div className='form-wizard-form-table table'>
      <table className='table table-striped table-striped-bg-black'>
        {colgroup}
        {headings}
        <tbody>
          <tr className={'table-default'}>
            <td>
              <Fields.Date
                name='date'
                dateFormat="MMM d, yyyy"
                // minDate={new Date()}
                selected={newConviction.date}
                value={newConviction.date}
                className='form-control'
                onChange={ev => setNewConviction({ ...newConviction, 'date': ev })}
                validators={['required']}
                errorMessages={['Please enter a valid date']}
              />
            </td>
            <td>
              <Fields.Select
                name='court'
                options={courts}
                value={newConviction.court}
                values={courts.filter(x => x.value === newConviction.court)}
                // onChange={ev => console.log(ev, ev.target)}
                onChange={ev => setNewConviction({ ...newConviction, 'court': ev?.length > 0 ? ev[0].value : '' })}
                className='form-control'
                validators={['required']}
                errorMessages={['Required']}
                required
              />
            </td>
            <td>
              <Fields.ComboField
                icon={null}
                id='conviction'
                name='conviction'
                capslock='true'
                options={criminalOffences}
                value={newConviction.conviction}
                className='form-control'
                style={{minHeight: '80px'}}
                // onChange={ev => console.log(ev, ev.target, ev.target?.value)}
                // onChange={ev => setNewConviction({ ...newConviction, [ev?.target?.name]: ev?.target?.value })}
                validators={['required']}
                errorMessages={['Required']}
                maxLength={100}
                required
                inputValue={newConviction}
                handleInputChange={setNewConviction}
                inputType='field'
              />
            </td>
            <td>
              <Fields.Textarea
                icon={null}
                id='sentence'
                name='sentence'
                value={newConviction.sentence}
                className='form-control'
                onChange={ev => setNewConviction({ ...newConviction, [ev?.target?.name]: ev?.target?.value })}
                validators={['required']}
                errorMessages={['Required']}
                maxLength={100}
                required
              />
            </td>
            <td>
              <button type='submit' className='btn btn-round btn-info'>
                Add Conviction
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )

  const tables = () => {
    if (!Array.isArray(criminalFields)) return null
    if (criminalFields.length < 1) return null

    // console.log(criminalFields);

    // const getRowClass = status => {
    //   switch (status) {
    //     case 'surplus':
    //       return 'table-success'
    //     case 'denied':
    //       return 'table-danger'
    //     case 'local purchase':
    //       return 'table-warning'
    //     default:
    //       return 'table-default'
    //   }
    // }

    const rows = criminalFields.map((row, i) => {
      return (
        <tr key={i} className={'table-default'}>
          <td>
            <Fields.Date
              name='date'
              dateFormat="MMM d, yyyy"
              // minDate={new Date()}
              selected={row?.date}
              value={row?.date}
              className='form-control'
              onChange={ev => on.setInput(ev, i, 'date')}
              validators={['required']}
              errorMessages={['Please enter a valid date']}
            />
          </td>
          <td>
            <Fields.Select
              name='court'
              options={courts}
              values={courts.filter(x => x.value === row.court)}
              onChange={ev => on.setInput(ev[0].value, i, 'court')}
              className='form-control'
              // validators={['required']}
              // errorMessages={['Required']}
              // required
            />
          </td>
          <td>
            <Fields.ComboField
              icon={null}
              id='conviction'
              name='conviction'
              capslock='true'
              options={criminalOffences}
              value={row?.conviction}
              className='form-control'
              style={{minHeight: '80px'}}
              // onChange={ev => on.setInput(ev.target.value, i, 'conviction')}
              validators={['required']}
              errorMessages={['Required']}
              maxLength={100}
              required
              inputValue={row?.conviction}
              handleInputChange={on.setInput}
              inputType='indexed'
              indexVal={i}
            />
          </td>
          <td>
            <Fields.Textarea
              icon={null}
              name='sentence'
              value={row?.sentence}
              className='form-control'
              onChange={ev => on.setInput(ev.target.value, i, 'sentence')}
              validators={['required']}
              errorMessages={['Required']}
              maxLength={100}
            />
          </td>
          <td>
            <button type='button' className='btn btn-round btn-danger' onClick={() => removeConvict(row)}>
              Remove Conviction
            </button>
          </td>
        </tr>
      )
    })

    return (
      <div key={'criminal_history'} className='form-wizard-form-table table'>
        <table className='table table-striped table-striped-bg-black'>
          {colgroup}
          {headings}
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <div style={{ maxWidth: '100%', width: '100%' }}>
      <div className='modal-header'>
        <h5 className='modal-title' style={{ paddingLeft: '10px', textTransform: 'capitalize' }}>
          Criminal History
          <br/>
          <b>{tableName}</b>
        </h5>
      </div>
        <div className='modal-body'>
          <ValidatorForm id='add-criminal-history-items' onSubmit={addConvict}>
            {addItemRow}
          </ValidatorForm>
          <ValidatorForm id='criminal-history-items' onSubmit={formSubmit}>
            {tables()}
          </ValidatorForm>
          <br />
          <div className='clearfix'>
            <strong style={{ paddingLeft: '10px' }}>Total # of Convictions:</strong>
            <strong className='float-right'>
              {Number(totalConvictions) || 'N/A'}
            </strong>
          </div>
        </div>
      <div className='modal-footer'>
        <button className='btn btn-round mr-2' onClick={closeModal}>
          Cancel
        </button>
        <input
          className='btn custom-btn btn-round'
          form='criminal-history-items'
          type='submit'
          value='Save History'
        />
      </div>
    </div>
  )
}
  
export {
  ItemCriminalHistory
}
